import ajax from '../ajax'

// //模型收入
export function AdminIcoMeLabelApi(params) {
    return ajax({
        method: 'get',
        url: '/v2/admin/devices',
        params
    })
}





// WEBPACK FOOTER //
// ./src/apis/gongju/index.js